"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MappingTable = void 0;
var react_1 = __importStar(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons = __importStar(require("@qwilr/kaleidoscope/icons"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var lodash_1 = require("lodash");
var UseTokens_1 = require("Tokens/UseTokens");
var styles = __importStar(require("./MappingTable.css"));
var inversify_react_1 = require("inversify-react");
var MappingTable = function (_a) {
    var fields = _a.fields, mappedTokenNames = _a.mappedTokenNames, onChange = _a.onChange, integrationData = _a.integrationData;
    var integrationName = integrationData.integrationName, displayName = integrationData.displayName, objectType = integrationData.objectType, objectDisplayName = integrationData.objectDisplayName;
    var notifyUser = (0, inversify_react_1.useInjection)("notifyUser");
    var refresh = (0, UseTokens_1.useTokensCache)().refresh;
    var onFieldChange = function (updatedField) {
        onChange(fields.map(function (field) { return (field.id === updatedField.id ? updatedField : field); }));
    };
    var onRefreshButtonClick = function () { return __awaiter(void 0, void 0, Promise, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4, refresh({ providerType: integrationName, objectType: objectType })];
                case 1:
                    _a.sent();
                    return [3, 3];
                case 2:
                    e_1 = _a.sent();
                    notifyUser.error("Unable to refresh ".concat(displayName, " tokens. Please try again."));
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    var Icon = (displayName && icons[(0, lodash_1.capitalize)(displayName)]) || icons.Tokens;
    var RefreshButtonTooltipContent = function () {
        return (react_1.default.createElement(kaleidoscope_1.Stack, { direction: "vertical", justify: "center" },
            react_1.default.createElement(kaleidoscope_1.Text, { theme: "dark", size: "s", strong: true }, "Refresh fields"),
            react_1.default.createElement(kaleidoscope_1.Text, { theme: "dark", size: "xs" }, "Refresh ".concat(displayName, " fields if you have recently added a new field you want to map to"),
                ".")));
    };
    return (react_1.default.createElement("div", { className: styles.wrapper },
        react_1.default.createElement("table", { className: styles.table },
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", { className: styles.tableRow },
                    react_1.default.createElement("th", { className: styles.leftColumn },
                        react_1.default.createElement(icons_1.Qwilr, null),
                        react_1.default.createElement(kaleidoscope_1.Text, { size: "m", strong: true }, "Qwilr")),
                    react_1.default.createElement("th", { className: styles.rightColumn },
                        react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.rightHeaderRow, direction: "horizontal", justify: "end", align: "center" },
                            react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.integrationName, direction: "horizontal", justify: "center", align: "center", gap: "xxs" },
                                react_1.default.createElement(Icon, null),
                                react_1.default.createElement(kaleidoscope_1.Text, { size: "m", strong: true }, "".concat(displayName, " (").concat(objectDisplayName, ")"))),
                            react_1.default.createElement(kaleidoscope_1.Tooltip, { content: react_1.default.createElement(RefreshButtonTooltipContent, null), size: kaleidoscope_1.TooltipSize.Large },
                                react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.Reset, null), type: kaleidoscope_1.ButtonType.Secondary, size: kaleidoscope_1.ButtonSize.Small, onClick: onRefreshButtonClick, "aria-label": "Refresh ".concat(displayName, " Fields") })))))),
            react_1.default.createElement("tbody", null, fields.length > 0 ? (fields.map(function (field) { return (react_1.default.createElement(TableRow, { key: field.id, field: field, mappedTokenNames: mappedTokenNames, onChange: onFieldChange, integrationData: integrationData })); })) : (react_1.default.createElement("tr", null,
                react_1.default.createElement("td", null,
                    react_1.default.createElement(kaleidoscope_1.Text, { size: "s", align: "center", className: styles.emptyFormState }, "There are no fields in this custom form"))))))));
};
exports.MappingTable = MappingTable;
var TableRow = function (_a) {
    var _b;
    var field = _a.field, mappedTokenNames = _a.mappedTokenNames, onChange = _a.onChange, _c = _a.integrationData, integrationName = _c.integrationName, objectType = _c.objectType;
    var _d = __read((0, react_1.useState)(""), 2), inputValue = _d[0], setInputValue = _d[1];
    var debouncedInputValue = useDebounce(inputValue, 1000);
    var _e = (0, UseTokens_1.useTokens)({
        providerType: integrationName,
        objectType: objectType,
        excludeReadOnly: true,
        query: debouncedInputValue,
    }), data = _e.data, isValidating = _e.isValidating;
    var onSelect = function (token) {
        if (token && mappedTokenNames.includes(token.apiName)) {
            return;
        }
        onChange(__assign(__assign({}, field), { to: token ? { apiName: token.apiName, name: token.name } : undefined }));
    };
    return (react_1.default.createElement("tr", { className: styles.tableRow },
        react_1.default.createElement("td", { className: styles.leftColumn },
            field.deleted ? (react_1.default.createElement(kaleidoscope_1.Text, { size: "s", secondary: true }, "This question has been deleted")) : field.name ? (react_1.default.createElement(kaleidoscope_1.Text, { size: "s" }, field.name)) : (react_1.default.createElement(kaleidoscope_1.Text, { size: "s", secondary: true }, "This question is empty.")),
            react_1.default.createElement(icons_1.ArrowRight, { className: styles.rightArrow({ highlight: field.to !== undefined }) })),
        react_1.default.createElement("td", { className: styles.rightColumn },
            react_1.default.createElement(kaleidoscope_1.Combobox, { value: (_b = field.to) !== null && _b !== void 0 ? _b : null, onChange: onSelect, options: data === undefined || isValidating || inputValue !== debouncedInputValue ? { isLoading: true } : data, getOptionKey: function (token) { return token.apiName; }, getOptionLabel: function (token) { return token.name; }, isOptionDisabled: function (token) { return mappedTokenNames.includes(token.apiName); }, renderOption: function (token) { return (react_1.default.createElement(kaleidoscope_1.Tooltip, { size: kaleidoscope_1.TooltipSize.Large, show: mappedTokenNames.includes(token.apiName) ? undefined : false, content: "This field has already been chosen in the mapping." },
                    react_1.default.createElement(kaleidoscope_1.Text, { className: styles.tokenText, element: "div" }, token.name))); }, renderInput: function (props) { return (react_1.default.createElement(kaleidoscope_1.TextInput, __assign({ startElement: react_1.default.createElement(icons_1.Search, null), size: kaleidoscope_1.TextInputSize.Small, disabled: field.deleted, label: "", labelHidden: true, placeholder: "Search field" }, props))); }, onInputChange: setInputValue, renderClearButton: function (props) { return react_1.default.createElement(kaleidoscope_1.IconButton, __assign({ size: kaleidoscope_1.ButtonSize.XSmall, disabled: field.deleted }, props)); } }))));
};
function useDebounce(value, delay) {
    var _a = __read((0, react_1.useState)(value), 2), debouncedValue = _a[0], setDebouncedValue = _a[1];
    (0, react_1.useEffect)(function () {
        var handler = setTimeout(function () {
            setDebouncedValue(value);
        }, delay);
        return function () {
            clearTimeout(handler);
        };
    }, [value, delay]);
    return debouncedValue;
}
